export default "assets/images/flags/gb-1e6bc5ff.svg";